import { contentItems, audioAssets, pdfAssets, formatDuration } from "@/data/mockData";
import { Badge } from "@/components/ui/badge";
import { Headphones, FileText, Clock, BookOpen } from "lucide-react";

const featured = contentItems.filter(c => c.is_featured);

function ContentCard({ item }: { item: typeof contentItems[0] }) {
  const audio = audioAssets.find(a => a.content_item_id === item.id);
  const pdf = pdfAssets.find(p => p.content_item_id === item.id);

  return (
    <div className="bg-card rounded-xl border border-border overflow-hidden hover:shadow-lg transition-shadow group">
      <div className="aspect-[3/4] relative overflow-hidden">
        <img src={item.cover_image_url} alt={item.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
        <div className="absolute top-3 left-3 flex gap-1.5">
          {(item.content_type === "audio" || item.content_type === "mixed") && (
            <Badge className="bg-primary text-primary-foreground text-xs"><Headphones className="h-3 w-3 mr-1" />Audio</Badge>
          )}
          {(item.content_type === "pdf" || item.content_type === "mixed") && (
            <Badge className="bg-accent-gold text-accent-gold-foreground text-xs"><FileText className="h-3 w-3 mr-1" />PDF</Badge>
          )}
        </div>
      </div>
      <div className="p-4">
        <p className="text-xs text-muted-foreground font-body mb-1">{item.author}</p>
        <h3 className="font-heading font-bold text-foreground mb-1 leading-snug">{item.title}</h3>
        <p className="text-sm text-muted-foreground line-clamp-2 mb-3">{item.description_short}</p>
        <div className="flex items-center gap-3 text-xs text-muted-foreground">
          {audio && (
            <span className="flex items-center gap-1"><Clock className="h-3 w-3" />{formatDuration(audio.total_duration_seconds)}</span>
          )}
          {pdf && (
            <span className="flex items-center gap-1"><BookOpen className="h-3 w-3" />{pdf.page_count} pág.</span>
          )}
        </div>
      </div>
    </div>
  );
}

export function FeaturedContent() {
  return (
    <section id="featured" className="py-24">
      <div className="container mx-auto px-4">
        <h2 className="text-3xl md:text-4xl font-heading font-bold text-center text-foreground mb-4">
          Contenido destacado
        </h2>
        <p className="text-center text-muted-foreground mb-12 max-w-lg mx-auto">
          Los títulos más populares de nuestra biblioteca.
        </p>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6 max-w-6xl mx-auto">
          {featured.map(item => (
            <ContentCard key={item.id} item={item} />
          ))}
        </div>
      </div>
    </section>
  );
}
